import React, { useEffect, useState } from "react";
import { http } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("toate");

  useEffect(() => {
    http.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "toate" ? products : products.filter((p) => p.collection === filter);

  const filters = [
    { id: "toate", label: "Toate" },
    { id: "principala", label: "Ediția Principală" },
    { id: "halloween", label: "Halloween" },
    { id: "bundle", label: "Pachete" },
  ];

  return (
    <div className="py-16 md:py-24" data-testid="shop-page">
      <div className="container-vdz">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow mb-3">Magazin</div>
          <h1 className="font-serif-display text-5xl md:text-6xl" style={{ color: "var(--vdz-navy)" }}>Cărțile Vis de Zi</h1>
          <p className="mt-5 opacity-75 leading-relaxed">
            Cărți de colorat elegante pentru adulți — ilustrate și create cu drag de Alina Stancu.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-12" data-testid="shop-filters">
          {filters.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              data-testid={`shop-filter-${f.id}`}
              className={`px-5 py-2 text-xs uppercase tracking-[0.2em] font-serif-accent border transition-all ${
                filter === f.id ? "bg-[color:var(--vdz-navy)] text-[color:var(--vdz-cream)] border-[color:var(--vdz-navy)]" : "bg-white text-[color:var(--vdz-navy)] border-[color:var(--vdz-cream-border)] hover:border-[color:var(--vdz-gold)]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="shop-products-grid">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 opacity-60">
            <p className="font-serif-display text-xl">Nicio carte în această colecție deocamdată.</p>
          </div>
        )}
      </div>
    </div>
  );
}
